import Http from "./Http";

export class LocationBlockerService extends Http {
  /**
   * Get location blocker locations
   */
  getLocationBlockerLocations() {
    return this.get(`/location-blockers/locations`);
  }

  /**
   * Set location blocker
   */
  setLocationBlocker(body) {
    return this.post(`/location-blockers/locations`, body);
  }

  /**
   * Delete location blocker
   */
  deleteLocationBlocker({ id }) {
    return this.delete(`/location-blockers/locations/${id}`);
  }
}

LocationBlockerService.$displayName = "LocationBlockerService";

export default new LocationBlockerService();
